export default __webpack_public_path__ + "static/media/spinner.7815efb3.gif";